import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from '../../services/localStorage/local-storage.service';
import { AuthStateService } from '../../services/auth-state/auth-state-service.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);
  const authStateService = inject(AuthStateService);

  if (localStorageService.isAuthenticated()) {
    if (state.url === '/' || state.url === '') {
      router.navigateByUrl(authStateService.getRedirectUrl());
      return false;
    }
    return true;
  } else {
    localStorageService.reset();
    const redirect = state.url && state.url !== '/' ? state.url : undefined;
    router.navigate(['/login'], redirect ? { queryParams: { redirect } } : undefined);
    return false;
  }
};
